import { mockData } from 'utils/mockData/mock';
import { rootStore } from 'store/rootStore';

// function checkVersion(response) {
//   // Отрезаем номер сборки
//   const hybridVersion = response.headers
//     .get('hybrid-version')
//     .substring(0, response.headers.get('hybrid-version').lastIndexOf('.'));
//   // const hybridVersion = '1.5.0';
//   const prevVersion = store.getState().app.version;
//   if (hybridVersion !== prevVersion) {
//     prevVersion ? store.dispatch(setVersionModal(true)) : store.dispatch(setNewVersion(hybridVersion));
//   }
//   if (
//     hybridVersion.includes(APP_SETTINGS.FEATURES_MODAL_VERSION) &&
//     hybridVersion !== window.localStorage.getItem('reports-version-control')
//   ) {
//     window.localStorage.removeItem('reports-new-feature');
//   }
//   if (!hybridVersion.includes(APP_SETTINGS.FEATURES_MODAL_VERSION)) {
//     window.localStorage.setItem('reports-new-feature', 'hide');
//   }
//
//   window.localStorage.setItem('reports-version-control', hybridVersion);
//   return response;
// }

class QueryClass {
  headers = new Headers();

  constructor() {
    this.headers.set('Content-type', 'application/json');
  }

  getRequest({ url, noReloadPage401 = false }) {
    const to = typeof url === 'function' ? url() : url;

    return (
      fetch(to, {
        credentials: 'include',
        method: 'GET',
        headers: this.headers,
      })
        .then((response) => this.catchErrors({ response, url, noReloadPage401 }))
        // .then(checkVersion)
        .then((data) => {
          if (data?.isMock) {
            return data.body;
          }

          if (data.status === 204) {
            return 'success';
          } else if (data.status !== 200) {
            return data;
          } else {
            return this.returnResult(data);
          }
        })
    );
  }

  postRequest({ url, data, file = false, noReloadPage401 = false }) {
    const to = typeof url === 'function' ? url() : url;

    return fetch(to, {
      credentials: 'include',
      method: 'POST',
      headers: this.headers,
      body: JSON.stringify(data),
    })
      .then((response) => this.catchErrors({ response, url, noReloadPage401 }))
      .then((data) => {
        if (data?.isMock) {
          return data.body;
        }

        if (data.status === 204) {
          return 'success';
        } else if (data.status !== 200) {
          return data;
        } else {
          if (file) {
            return data.blob();
          }
          return this.returnResult(data);
        }
      });
  }

  deleteRequest({ url }) {
    const to = typeof url === 'function' ? url() : url;

    return fetch(to, {
      credentials: 'include',
      method: 'DELETE',
      headers: this.headers,
    })
      .then((response) => this.catchErrors({ response, url }))
      .then((data) => {
        if (data?.isMock) {
          return data.body;
        }

        if (data.status === 204 || data.status === 200) {
          return 'success';
        } else {
          return this.returnResult(data);
        }
      });
  }

  returnResult(data) {
    const contentType = data.headers.get('content-type') || '';
    const isJson = contentType.includes('application/json');
    const isText =
      contentType.includes('text/plain') || contentType.includes('text/html') || contentType.includes('text/');

    if (isJson) {
      return data.json();
    } else if (isText) {
      return data.text();
    } else {
      // Для остальных типов — возвращаем сырой response
      return data || 'success';
    }
  }

  catchErrors({ response, url, noReloadPage401 }) {
    if (!response.ok) {
      this.handleErrors(response, noReloadPage401);
      if (process.env.NODE_ENV === 'development') {
        const body = mockData({ url });
        return body ? { body, isMock: true } : Promise.reject(response);
      }

      return Promise.reject(response);
    }
    return response;
  }

  handleErrors({ status, statusText }, noReloadPage401) {
    switch (status) {
      case 401:
        if (noReloadPage401) {
          break;
        }
        window.location.href = '/core/login/index';
        break;
      case 404:
        rootStore.messageStore.setMessage({ data: { status, statusText }, type: 'error' });
        console.warn('Page not found');
        break;
      case 500:
        rootStore.messageStore.setMessage({ data: { status, statusText }, type: 'error' });
        break;
      default:
        rootStore.messageStore.setMessage({ data: { status, statusText }, type: 'error' });
        break;
    }
  }
}

export const query = new QueryClass();
